export default "__VITE_ASSET__BVerVCyX__"